import { AppContext } from './context';

export { withAuthConsumer, mapStateAuth } from './legacy';

export default AppContext;
